import React from 'react';

import { Box, ButtonBase, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { DateTime } from 'luxon';

import { DateFormatPatterns } from '@clearverify/constants';

import { SxProp } from 'src/types/mui';

import { proceedId } from '../auth/SignupVerifierPageForm/components/constants';
import { RelatedVerifier } from '../auth/SignupVerifierPageForm/types';
import { Avatar } from '../shared';

interface CompanyRelatedBlockProps {
  verifier?: RelatedVerifier;
  currentCompany?: RelatedVerifier;
  isProceed?: boolean;
  handleChange: (verifier?: RelatedVerifier) => void;
}

export const CompanyRelatedBlock: React.FC<CompanyRelatedBlockProps> = props => {
  const { verifier, isProceed = false, currentCompany, handleChange } = props;

  const formControlValue = !isProceed ? verifier?.id : proceedId;

  const onChange = () => {
    if (!isProceed) {
      handleChange(verifier);
    } else {
      handleChange({
        id: proceedId,
      });
    }
  };

  return (
    <ButtonBase component={Box} sx={companyBlockStyles} onClick={onChange}>
      {!isProceed && (
        <Avatar sx={avatarStyles} src={verifier?.logo?.downloadUrl} variant="circular" />
      )}
      <Box>
        <Typography variant="body2" fontSize="16px" fontWeight={600}>
          {!isProceed ? verifier?.displayName : 'Proceed as a Separate Company'}
        </Typography>
        {!isProceed && (
          <Typography variant="body2" fontSize="14px" sx={colorText}>
            Registered{' '}
            {DateTime.fromISO(String(verifier?.createdAt)).toFormat(
              DateFormatPatterns.shortDateWithSlash,
            )}
          </Typography>
        )}
        {verifier?.address?.street && verifier.address.state && !isProceed && (
          <Typography variant="body2" fontSize="14px" sx={colorText}>
            {verifier.address.street}, {verifier.address.state}
          </Typography>
        )}
      </Box>

      <RadioGroup
        name="verifier"
        value={currentCompany?.id || ''}
        onChange={onChange}
        sx={radioStyled}
      >
        <FormControlLabel value={formControlValue} control={<Radio />} label="" />
      </RadioGroup>
    </ButtonBase>
  );
};

const colorText: SxProp = {
  color: 'rgba(0, 0, 0, 0.6)',
};

const companyBlockStyles: SxProp = theme => ({
  border: theme.constantStyles?.paperBorder,
  padding: '20px  24px',
  display: 'flex',
  alignItems: 'center',
  marginTop: '24px',
  cursor: 'pointer',
});

const avatarStyles: SxProp = {
  width: 44,
  height: 44,
  mr: '13px',
};

const radioStyled: SxProp = {
  ml: 'auto',
};
